export const EVENT_CREATE_MODE = {
  ALBUM: 'ALBUM',
  GALLERY: 'GALLERY',
};

export const ALBUM_STANDALONE_SELECT_VALUE = 'ALBUM_STANDALONE_SELECT_VALUE';
export const ALBUM_FOLDER_SELECT_CREATE_NEW = 'ALBUM_FOLDER_SELECT_CREATE_NEW';

/**
 * Shutterbug album event type enum.
 *
 * @enum SHUTTERBUG_ALBUM_EVENT_TYPE
 * @type {{PARTY: string, SCHOOL: string, OTHER: string, LEAGUE: string, WEDDING: string}}
 */
export const SHUTTERBUG_ALBUM_EVENT_TYPE = {
  WEDDING: 'WEDDING',
  PARTY: 'PARTY',
  SCHOOL: 'SCHOOL',
  LEAGUE: 'LEAGUE',
  VACATION: 'VACATION',
  OTHER: 'OTHER',
};
